import { styled } from '@mui/system';

export const HeadingContainer = styled('div')(({ theme }) => ({
	display: 'flex',
	marginBottom: theme.spacing(0.5),
	justifyContent: 'space-between',
	'@media (max-width: 560px)': {
		display: 'block',
		marginTop: 15
	}
}));

export const LinkContainer = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	marginTop: theme.spacing(-1),
	marginBottom: theme.spacing(0.5),
	'@media (max-width: 560px)': {
		marginBottom: theme.spacing(1)
	}
}));

export const SchematicContainer = styled('div')(({ theme }) => ({
	marginLeft: '20px',
	'@media (max-width: 855px)': {
		marginTop: 20
	}
}));

export const ImageContainer = styled('div')(({ showInputParams }) => ({
	marginLeft: '80px',
	width: showInputParams ? '750px' : '1000px',
	'@media (max-width: 1050px)': {
		width: '600px',
		marginLeft: '60px'
	},
	'@media (max-width: 680px)': {
		width: '500px',
		marginLeft: '40px'
	},
	'@media (max-width: 560px)': {
		width: '400px',
		marginLeft: '15px'
	},
	'@media (max-width: 460px)': {
		width: '300px',
		marginLeft: '0px'
	},
	'@media (max-width: 360px)': {
		width: '200px'
	}
}));
